import { styled } from '@mui/system';
import { Props } from './types';

type T = Pick<Props, 'gap'>;

export const Content = styled('div')<T>`
  display: grid;
  grid-auto-flow: column;
  gap: ${({ gap }) => `${gap ?? 0}px`};
`;
